import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import type { UseNoticesReturnOne } from './useNotices'

const GET_LAST_UNREAD_NOTICE = '/api/list/notices/new'

const useLastUnreadNotice = () => {
  const {
    isLoading,
    data: noticeData,
    isError,
    error
  } = useQuery<UseNoticesReturnOne | undefined, unknown>(
    'lastUnreadNotice',
    () => getJSON({ url: GET_LAST_UNREAD_NOTICE }),
    {
      onError: (error) => {
        if (is404Error(error)) {
          // eslint-disable-next-line no-console
          console.log(error)
        }
      }
    }
  )

  return {
    isLoading,
    result: noticeData?.result,
    isError,
    error
  }
}

function is404Error(error: unknown): error is { status: number } {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    error.status === 404
  )
}

export default useLastUnreadNotice
